










import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/header/MHeader.vue";
import PreRegisterForm from "@/components/forms/PreRegisterForm.vue";
import Footer from "@/components/Footer.vue";

@Component({
  components: {
    Header,
    PreRegisterForm,
    Footer,
  },
})
export default class MPreRegister extends Vue {}
